import { MessageSquare, FileText, PenTool, RefreshCw, Rocket } from "lucide-react";
import { Reveal } from "./Reveal";

const steps = [
  { icon: MessageSquare, title: "Nos escribes", text: "Cuéntanos sobre tu negocio y qué necesitas." },
  { icon: FileText, title: "Propuesta y presupuesto", text: "Sin compromiso, en menos de 24h." },
  { icon: PenTool, title: "Diseñamos tu web", text: "Empezamos a trabajar según el pack elegido." },
  { icon: RefreshCw, title: "Revisión y ajustes", text: "La afinamos juntos hasta que quede perfecta." },
  { icon: Rocket, title: "Publicación y entrega", text: "Tu web queda online, lista para captar clientes." },
];

export const Process = () => (
  <section id="proceso" data-testid="process-section" className="relative mx-auto max-w-7xl px-5 py-24 md:px-10 md:py-32">
    <Reveal className="max-w-2xl">
      <span className="text-sm font-medium uppercase tracking-[0.25em] text-[#00E5FF]">04 — Nuestro proceso</span>
      <h2 className="mt-5 font-head text-4xl font-light leading-tight tracking-tight text-white sm:text-5xl">
        Cómo <span className="font-black">trabajamos</span>
      </h2>
      <p className="mt-5 text-lg text-zinc-400">De la primera idea a tu web publicada en cinco pasos claros.</p>
    </Reveal>

    <div className="relative mt-16">
      {/* connecting line */}
      <div className="pointer-events-none absolute left-6 top-6 hidden h-[calc(100%-3rem)] w-px bg-gradient-to-b from-[#00E5FF]/60 to-transparent md:left-0 md:top-8 md:h-px md:w-full md:bg-gradient-to-r lg:block" />

      <div className="grid grid-cols-1 gap-10 md:grid-cols-5 md:gap-6">
        {steps.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.title} delay={i * 0.1} className="relative">
              <div className="flex items-center gap-4 md:block">
                <div className="relative z-10 flex h-14 w-14 flex-shrink-0 items-center justify-center rounded-2xl border border-white/10 bg-[#101018] text-[#00E5FF] transition-colors hover:border-[#00E5FF]/60">
                  <Icon className="h-6 w-6" />
                  <span className="absolute -right-2 -top-2 flex h-6 w-6 items-center justify-center rounded-full bg-[#00E5FF] font-head text-xs font-bold text-[#0A0A0C]">
                    {i + 1}
                  </span>
                </div>
                <div className="md:mt-6">
                  <h3 className="font-head text-lg font-semibold text-white">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-zinc-400">{s.text}</p>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
